import React, { Component } from 'react';
import Button from "@material-ui/core/Button";
import NonOpImage from "../../assets/non-op.png";
import "./JointNoi1.css"

class JointNoi7 extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <div id="RCPE-Welcome-main-container">
                <div id="all-content-wrapper">
                    <div id="RCPE-Welcome-box-1">
                        <div id="JointNoi3-inner-box-1">

                            {/* Dic 1 */}
                            <div id="RCPNOI-container-1">
                                <h2 id="RCPNOI-heading"> {`Reducing pain, Improving Joint Function and slowing the progression of arthritis`} </h2>

                                <div id="RCPNOI-form-box-1">
                                    <form id="RCPNOI-form">
                                            
                                        <ul className="RCPNOI-unstyled RCPNOIcentered">

                                            {["Home Exercise","Nutritional support","Smoking Cessation","Reducing your Anxiety","Managing your Discomfort","Complementary alternative pain treatments"].map((text)=>
                                                <li>
                                                    <label htmlFor={text} className="RCPNOI-form-field">
                                                        {text}
                                                    </label>
                                                   
                                                    {/* <span className="RCPNOI-square-box">

                                                    </span>
                                                    <span className="RCPNOI-text-field">
                                                        {text}
                                                    </span> */}
                                                </li>
                                            )}
                                        </ul>      
                                    </form>

                                    <img alt="App-Image" src={NonOpImage} id="JN1-Image" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="RCPE-Welcome-box-2">
                        <div id="RCPE-Welcome-footer-div1">
                            <Button
                                id="RCPE-Welcome-btn-1"
                                variant="contained"
                                onClick={this.props.handleBackClick}
                            >
                                {" "} Back {" "}
                            </Button>
                        </div>

                        <div id="RCPE-Welcome-footer-div3">
                            <Button
                                id="RCPE-Welcome-btn-3"
                                variant="contained"
                                onClick={this.props.handleNextClick}
                            >
                                {" "} Next {" "}
                            </Button>
                        </div>
                    </div>

                </div>
                
            </div>
        );
    }
}

export default JointNoi7;